import { render, staticRenderFns } from "./IconFlows.vue?vue&type=template&id=6fa394fe&"
import script from "./IconFlows.vue?vue&type=script&lang=ts&"
export * from "./IconFlows.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports